import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import { Link } from "react-router-dom";
import { createBrowserHistory } from "history";
import { Dropdown } from "react-bootstrap";
import RolesSidebar from "./RolesSidebar";
import {
  UpdateFieldRolePermission
} from "../../../actions/RolePermissionActions";
import {
  GetRole2,
  SaveRole2,
  DeleteRole2,
  UpdateUsersInRole,
  GetRoleList
} from "../../../actions/RoleActions";
import UserSelect from "../../../components/UserSelect";
const RolesView = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const roleInfo = useSelector((state) => state.roleInfo.value);
  const roleListInfo = useSelector((state) => state.roleListInfo.value);
  const [currentRp, updateCurrentRp] = useState({
    //id: 0,
    roleId: -1,
    businessProcessId: false,
    allChecked: false,
    canEditProps: false,
    canEditTemplate: false,
    canDelete: false,
    canImageReview: false,
    canApprove: false,
    canEdit: false,
    canAddNote: false,
    canViewActiveDoc: false,
    canViewConf: false,
    canUpload: false,
    canDownload: false,
    canView: false,
    businessProcessName: ""
  });
  const [currentView, updateCurrentView] = useState("roles");
  const [currentRole, updateCurrentRole] = useState({
    id: 0,
    name: "",
    licenseLevel: 0,
    permissions: []
  });
  const [bpList, updateBpList] = useState([]);
  const [showAddUser, updateShowAddUser] = useState(false);
  const [addUserDirty, updateAddUserDirty] = useState(false);
  const [currentLicenseLevel, updateCurrentLicenseLevel] = useState("3");
  const [currentLicenseName, updateCurrentLicenseName] = useState("Admin");
  const [rolePermissionList, updateRolePermissionList] = useState([]);
  const [selectedBp, updateSelectedBp] = useState("Select BP");
  const [roleId, updateRoleId] = useState(0);
  const [displayBPSelectDropdown, updateDisplayBPSelectDropdown] = useState(false);
  const [currentLicStyle, updateCurrentLicStyle] = useState("btn-primary");
  const [confirmDeleteBox, updateConfirmDeleteBox] = useState(false);
  const [wfStepRPList, updateWfStepRPList] = useState([]);
  const [allFields, updateAllFields] = useState([]);
  const [fieldPermissionsDirty, updateFieldPermissionsDirty] = useState(false);
  const [currentFieldPermissionSet, updateCurrentFieldPermissionSet] = useState([]);
  const [wfStepsDisplay, updateWfStepsDisplay] = useState(false);
  const [allStepsChecked, updateAllStepsChecked] = useState(false);
  const [users, updateUsers] = useState([]);
  const [allUsers, updateAllUsers] = useState([]);
  const [currentBp, updateCurrentBp] = useState(0);
  const [displayUsers, updateDisplayUsers] = useState(false);
  const [selectedUser, updateSelectedUser] = useState(void 0);
  const [screenHeight, updateScreenHeight] = useState(window.innerHeight - 140);
  const [bottomHeight, updateBottomHeight] = useState((window.innerHeight - 230) * 0.4);
  const [isDirty, updateIsDirty] = useState(false);
  const [hasError, updateHasError] = useState(false);
  const [errorMessage, updateErrorMessage] = useState("");
  const [currentUrl, updateCurrentUrl] = useState("");
  const [roleType, updateRoleType] = useState("TrinDocs");
  const [trinFormsPermissions, updateTrinFormsPermissions] = useState([]);
  useEffect(() => {
    document.title = "TrinDocs - Roles";
    let loc = window.location.pathname;
    let pathParts = loc.split("/");
    let roleId2 = parseInt(pathParts[pathParts.length - 1], 10);
    console.log("role info is here");
    console.log(roleInfo);
    if (roleInfo.loaded) {
      updateRoleType("TrinDocs");
      if (roleInfo.role.id !== 0 && roleId2 === 0 && roleInfo.newRole) {
        setRole(roleInfo.role);
        let loc2 = window.location.pathname;
        loc2 = loc2.replace("0", roleInfo.role.id);
        window.history.pushState({}, null, loc2);
      } else if (roleInfo.role.id !== roleId2 && roleInfo.role.id !== void 0) {
        GetRole2(roleId2, dispatch);
      } else if (roleId2 === roleInfo.role.id && roleId2 !== 0) {
        setRole(roleInfo.role);
      } else {
        setNewRoleInfo();
      }
    } else {
      loadBPFromDB();
    }
    if (roleInfo.deleted) {
      updateConfirmDeleteBox(false);
      let link = document.getElementById("rolesHomeLink");
      link.click();
    }
    if (roleInfo.deleteFailed && currentUrl === location.pathname) {
      updateHasError(true);
      updateErrorMessage(roleInfo.message);
    }
    updateCurrentUrl(location.pathname);
  }, [roleInfo, roleListInfo, location]);
  const loadBPFromDB = () => {
    let loc = window.location.pathname;
    let pathParts = loc.split("/");
    let roleId2 = parseInt(pathParts[pathParts.length - 1], 10);
    if (roleId2 === 0) {
      setNewRoleInfo();
    } else if (roleId2 !== 0) {
      GetRole2(roleId2, dispatch);
    }
  };
  const setNewRoleInfo = () => {
    let newRole = {
      id: 0,
      name: "",
      licenseLevel: 1,
      permissions: [],
      trinFormsPermissions: [],
      type: ""
    };
    updateCurrentRole(newRole);
    updateRoleId(roleId);
    updateRolePermissionList([]);
    updateWfStepsDisplay(false);
    updateCurrentLicenseLevel(1);
    updateRolePermissionList(newRole.permissions);
    updateTrinFormsPermissions(newRole.trinFormsPermissions);
    updateCurrentLicenseName("Viewer");
    updateCurrentLicStyle("btn-warning");
    updateRoleType("TrinDocs");
    newRole.type = "TrinDocs";
    updateCurrentRole(newRole);
  };
  const setRole = (role) => {
    let name = "";
    let style = "";
    if (roleType === "TrinDocs") {
      switch (role.licenseLevel) {
        case 4:
          name = "System Manager";
          style = "btn-danger";
          break;
        case 3:
          name = "Admin";
          style = "btn-success";
          break;
        case 2:
          name = "Approver";
          style = "btn-primary";
          break;
        case 1:
          name = "Viewer";
          style = "btn-warning";
          break;
        default:
      }
    } else {
      switch (role.licenseLevel) {
        case 2:
          name = "Admin";
          style = "btn-success";
          break;
        case 1:
          name = "Viewer";
          style = "btn-primary";
          break;
        default:
      }
    }
    updateRolePermissionList(role.permissions);
    updateTrinFormsPermissions(role.trinFormsPermissions);
    if (role.permissions.length > 0) {
      updateCurrentBp(role.permissions[0].bpId);
      updateWfStepsDisplay(true);
      updateAllStepsChecked(false);
      updateWfStepRPList(role.permissions[0].stepPermissions);
      updateCurrentFieldPermissionSet(role.permissions[0].groups);
      updateAllFields(role.permissions[0].allFields);
    } else {
      updateCurrentBp(0);
      updateWfStepsDisplay(false);
    }
    updateCurrentRole(role);
    updateCurrentLicenseLevel(role.licenseLevel);
    updateCurrentLicenseName(name);
    updateCurrentLicStyle(style);
    updateUsers(role.currentUsersInRole);
    updateAllUsers(role.permittedUsers);
    updateBpList(role.bpInfo);
  };
  const switchBP = (bp) => {
    updateCurrentBp(bp.bpId);
    updateWfStepsDisplay(true);
    updateAllStepsChecked(false);
    updateWfStepRPList(bp.stepPermissions);
    updateCurrentFieldPermissionSet(bp.groups);
    updateAllFields(bp.allFields);
  };
  const onShowUsers = () => {
    updateDisplayUsers(true);
  };
  const onSaveClick = () => {
    SaveRole2(
      dispatch,
      currentRole
    );
    updateIsDirty(false);
  };
  const openDeleteBox = () => {
    updateConfirmDeleteBox(true);
  };
  const closeModal = () => {
    updateConfirmDeleteBox(false);
    updateDisplayUsers(false);
    updateHasError(false);
  };
  const closeWfStepSection = () => {
    updateWfStepsDisplay(false);
  };
  const deleteRoleConfirmed = () => {
    DeleteRole2(currentRole.id, dispatch);
  };
  const deleteRolePermission = (rp) => {
    let role = currentRole;
    let rpList = [...role.permissions];
    let permission = rpList.find((p) => p.bpId === rp.bpId);
    if (permission) {
      let idx = rpList.indexOf(permission);
      rpList.splice(idx, 1);
    }
    let updatedRole = JSON.parse(JSON.stringify(currentRole));
    updatedRole.permissions = rpList;
    updateCurrentRole(updatedRole);
    updateRolePermissionList(rpList);
    updateIsDirty(true);
  };
  const deleteTrinFormsRolePermission = (rp) => {
    let role = currentRole;
    let rpList = [...role.trinFormsPermissions];
    let permission = rpList.find((p) => p.bpId === rp.bpId);
    if (permission) {
      let idx = rpList.indexOf(permission);
      rpList.splice(idx, 1);
    }
    let updatedRole = JSON.parse(JSON.stringify(currentRole));
    updatedRole.trinFormsPermissions = rpList;
    updateCurrentRole(updatedRole);
    updateTrinFormsPermissions(rpList);
    updateIsDirty(true);
  };
  const setLicenseLevel = (levelId) => {
    let name = "";
    let style = "";
    switch (levelId) {
      case 3:
        name = "Admin";
        style = "btn-success";
        break;
      case 2:
        name = "Approver";
        style = "btn-primary";
        break;
      case 1:
        name = "Viewer";
        style = "btn-warning";
        break;
      default:
    }
    let role = JSON.parse(JSON.stringify(currentRole));
    role.licenseLevel = levelId;
    updateIsDirty(true);
    let rpList = [...rolePermissionList];
    let updatedList = [];
    rpList.forEach((rp) => {
      let item = JSON.parse(JSON.stringify(rp));
      switch (levelId) {
        case 4:
          break;
        case 3:
          name = "Admin";
          break;
        case 2:
          name = "Approver";
          item.canEditProps = false;
          item.canEditTemplate = false;
          item.canDelete = false;
          item.canImageReview = false;
          break;
        case 1:
          item.canEditProps = false;
          item.canEditTemplate = false;
          item.canDelete = false;
          item.canImageReview = false;
          item.canApprove = false;
          item.canEdit = false;
          name = "Viewer";
          style = "btn-warning";
          break;
        default:
      }
      updatedList.push(item);
      return 0;
    });
    updateCurrentLicenseLevel(levelId);
    updateCurrentLicenseName(name);
    updateCurrentLicStyle(style);
    updateCurrentRole(role);
    updateRolePermissionList(updatedList);
  };
  const setTrinFormsLicenseLevel = (levelId) => {
    let name = "";
    let style = "";
    switch (levelId) {
      case 2:
        name = "Admin";
        style = "btn-success";
        break;
      case 1:
        name = "Standard";
        style = "btn-primary";
        break;
      default:
    }
    let role = JSON.parse(JSON.stringify(currentRole));
    role.licenseLevel = levelId;
    updateIsDirty(true);
    let rpList = [...trinFormsPermissions];
    console.log("rp list?");
    console.log(rpList);
    let updatedList = [];
    rpList.forEach((rp) => {
      let item = JSON.parse(JSON.stringify(rp));
      switch (levelId) {
        case 4:
          break;
        case 2:
          name = "Admin";
          break;
        case 1:
          name = "Standard";
          item.canPerformAdminActions = false;
          break;
        default:
      }
      updatedList.push(item);
      return 0;
    });
    updateCurrentLicenseLevel(levelId);
    updateCurrentLicenseName(name);
    updateCurrentLicStyle(style);
    updateCurrentRole(role);
    updateTrinFormsPermissions(updatedList);
  };
  const handleNewBPDropdown = (e) => {
    let bpId = parseInt(e.target.value);
    let bp = bpList.find((f) => f.bpId === bpId);
    if (bp) {
      let newRolePermission = {
        id: 0,
        roleId,
        bpId: bp.bpId,
        allChecked: false,
        canEditProps: false,
        canEditTemplate: false,
        canDelete: false,
        canImageReview: false,
        canApprove: false,
        canEdit: false,
        canAddNote: false,
        canViewActiveDoc: false,
        canViewConf: false,
        canUpload: false,
        canDownload: false,
        canView: false,
        bpName: bp.bpName,
        currentBp: 0
      };
      updateSelectedBp(bp.bpName);
      updateCurrentRp(newRolePermission);
    }
  };
  const addNewRPToList = () => {
    let rpList = [...rolePermissionList];
    var chosenBp = bpList.find((bp) => bp.bpId === currentRp.bpId);
    if (chosenBp) {
      var newBp = {
        allFields: [...chosenBp.allFields],
        bpId: chosenBp.bpId,
        bpName: chosenBp.bpName,
        bpType: null,
        allChecked: false,
        canAddNotes: false,
        canApprove: false,
        canDelete: false,
        canDownload: false,
        canEditFields: false,
        canImageReview: false,
        canMoveAssign: false,
        canSearchAllSteps: false,
        canTemplate: false,
        canUpload: false,
        canView: false,
        canViewActiveDocs: false,
        ftpId: null,
        groups: [],
        stepPermissions: [...chosenBp.steps]
      };
      rpList.push(newBp);
    }
    updateRolePermissionList(rpList);
    updateDisplayBPSelectDropdown(false);
    updateIsDirty(true);
  };
  const addNewTrinFormsBPToList = () => {
    let rpList = [...trinFormsPermissions];
    var chosenBp = bpList.find((bp) => bp.bpId === currentRp.bpId);
    if (chosenBp) {
      let newTrinFormsPermission = {
        id: 0,
        bpId: chosenBp.bpId,
        bpName: chosenBp.bpName,
        roleId,
        businessProcessId: chosenBp.bpId,
        allChecked: false,
        canPerformAdminActions: false,
        canApprove: false,
        canEdit: false,
        canCreate: false,
        canUnrestrictedSearch: false
      };
      rpList.push(newTrinFormsPermission);
    }
    updateTrinFormsPermissions(rpList);
    updateDisplayBPSelectDropdown(false);
    updateIsDirty(true);
  };
  const filterBPList = () => {
    let bpListCopy = bpList.slice();
    bpList.forEach((element) => {
      if (rolePermissionList.filter(
        (e) => e.businessProcessId === element.bpId
      ).length > 0) {
        let permissionMaybe = bpListCopy.filter((e) => e.bpId === element.bpId);
        const index = bpListCopy.indexOf(permissionMaybe[0]);
        if (index > -1) {
          bpListCopy.splice(index, 1);
        }
      }
    });
    if (bpListCopy.length > 0) {
      let bp = bpListCopy[0];
      console.log(bp);
      let newRolePermission = {
        id: 0,
        bpId: bp.bpId,
        bpName: bp.bpName,
        roleId,
        businessProcessId: bp.bpId,
        allChecked: false,
        canEditProps: false,
        canEditTemplate: false,
        canDelete: false,
        canImageReview: false,
        canApprove: false,
        canEdit: false,
        canAddNote: false,
        canViewActiveDoc: false,
        canViewConf: false,
        canUpload: false,
        canDownload: false,
        canView: false,
        groups: [],
        stepPermissions: [...bp.steps]
      };
      updateCurrentRp(newRolePermission);
    }
    updateBpList(bpListCopy);
    updateDisplayBPSelectDropdown(true);
  };
  const filterTrinFormsBPList = () => {
    let bpListCopy = trinFormsPermissions.slice();
    bpList.forEach((element) => {
      if (trinFormsPermissions.filter(
        (e) => e.businessProcessId === element.bpId
      ).length > 0) {
        let permissionMaybe = bpListCopy.filter((e) => e.bpId === element.bpId);
        const index = bpListCopy.indexOf(permissionMaybe[0]);
        if (index > -1) {
          bpListCopy.splice(index, 1);
        }
      }
    });
    if (bpListCopy.length > 0) {
      let bp = bpListCopy[0];
      let newTrinFormsPermission = {
        id: 0,
        bpId: bp.bpId,
        bpName: bp.bpName,
        roleId,
        businessProcessId: bp.bpId,
        allChecked: false,
        canPerformAdminActions: false,
        canApprove: false,
        canEdit: false,
        canCreate: false,
        canUnrestrictedSearch: false
      };
      updateCurrentRp(newTrinFormsPermission);
    }
    updateTrinFormsPermissions(bpListCopy);
    updateDisplayBPSelectDropdown(true);
  };
  const onSelectAllAvailable = (rp) => {
    let newPermissionList = [];
    if (rp.allChecked === true) {
      newPermissionList = rolePermissionList.map(
        (item) => item.bpId === rp.bpId ? {
          ...item,
          allChecked: false,
          canMoveAssign: false,
          canEditProps: false,
          canTemplate: false,
          canDelete: false,
          canImageReview: false,
          canApprove: false,
          canEditFields: false,
          canAddNotes: false,
          canViewActiveDocs: false,
          canViewConf: false,
          canUpload: false,
          canDownload: false,
          canView: false,
          canSearchAllSteps: false
        } : item
      );
    } else {
      newPermissionList = rolePermissionList.map(
        (item) => item.bpId === rp.bpId ? {
          ...item,
          allChecked: true,
          // admin section
          canMoveAssign: currentLicenseLevel >= 3 ? true : item.canMoveAssign,
          canTemplate: currentLicenseLevel >= 3 ? true : item.canTemplate,
          canDelete: currentLicenseLevel >= 3 ? true : item.canDelete,
          canImageReview: currentLicenseLevel >= 3 ? true : item.canImageReview,
          canEditProps: currentLicenseLevel >= 3 ? true : item.canEditProps,
          // approver section
          canApprove: currentLicenseLevel >= 2 ? true : item.canApprove,
          canEditFields: currentLicenseLevel >= 2 ? true : item.canEditFields,
          // viewer section
          canAddNotes: currentLicenseLevel >= 1 ? true : item.canAddNotes,
          canViewActiveDocs: currentLicenseLevel >= 1 ? true : item.canViewActiveDocs,
          canViewConf: currentLicenseLevel >= 1 ? true : item.canViewConf,
          canUpload: currentLicenseLevel >= 1 ? true : item.canUpload,
          canDownload: currentLicenseLevel >= 1 ? true : item.canDownload,
          canView: currentLicenseLevel >= 1 ? true : item.canView,
          canSearchAllSteps: currentLicenseLevel >= 1 ? true : item.canSearchAllSteps
        } : item
      );
    }
    let updatedRole = JSON.parse(JSON.stringify(currentRole));
    updatedRole.permissions = newPermissionList;
    updateCurrentRole(updatedRole);
    updateRolePermissionList(newPermissionList);
    updateIsDirty(true);
  };
  const onChangePermission = (type, e) => {
    let newPermissionList = [];
    switch (type) {
      case "canMoveAssign":
        newPermissionList = rolePermissionList.map(
          (item) => item.bpId === e.bpId ? { ...item, canMoveAssign: !e.canMoveAssign } : item
        );
        break;
      case "canTemplate":
        newPermissionList = rolePermissionList.map(
          (item) => item.bpId === e.bpId ? { ...item, canTemplate: !e.canTemplate } : item
        );
        break;
      case "canDelete":
        newPermissionList = rolePermissionList.map(
          (item) => item.bpId === e.bpId ? { ...item, canDelete: !e.canDelete } : item
        );
        break;
      case "canImageReview":
        newPermissionList = rolePermissionList.map(
          (item) => item.bpId === e.bpId ? { ...item, canImageReview: !e.canImageReview } : item
        );
        break;
      case "canApprove":
        newPermissionList = rolePermissionList.map(
          (item) => item.bpId === e.bpId ? { ...item, canApprove: !e.canApprove } : item
        );
        break;
      case "canEditFields":
        newPermissionList = rolePermissionList.map(
          (item) => item.bpId === e.bpId ? { ...item, canEditFields: !e.canEditFields } : item
        );
        break;
      case "canAddNotes":
        newPermissionList = rolePermissionList.map(
          (item) => item.bpId === e.bpId ? { ...item, canAddNotes: !e.canAddNotes } : item
        );
        break;
      case "canViewActiveDocs":
        newPermissionList = rolePermissionList.map(
          (item) => item.bpId === e.bpId ? { ...item, canViewActiveDocs: !e.canViewActiveDocs } : item
        );
        break;
      case "canViewConf":
        newPermissionList = rolePermissionList.map(
          (item) => item.bpId === e.bpId ? { ...item, canViewConf: !e.canViewConf } : item
        );
        break;
      case "canUpload":
        newPermissionList = rolePermissionList.map(
          (item) => item.bpId === e.bpId ? { ...item, canUpload: !e.canUpload } : item
        );
        break;
      case "canDownload":
        newPermissionList = rolePermissionList.map(
          (item) => item.bpId === e.bpId ? { ...item, canDownload: !e.canDownload } : item
        );
        break;
      case "canView":
        newPermissionList = rolePermissionList.map(
          (item) => item.bpId === e.bpId ? { ...item, canView: !e.canView } : item
        );
        break;
      case "canSearchAllSteps":
        newPermissionList = rolePermissionList.map(
          (item) => item.bpId === e.bpId ? { ...item, canSearchAllSteps: !e.canSearchAllSteps } : item
        );
        break;
      default:
        newPermissionList = [...rolePermissionList];
        break;
    }
    let updatedRole = JSON.parse(JSON.stringify(currentRole));
    updatedRole.permissions = newPermissionList;
    updateCurrentRole(updatedRole);
    updateIsDirty(true);
    updateRolePermissionList(newPermissionList);
  };
  const onChangeTrinFormsPermission = (type, e) => {
    let newPermissionList = [];
    switch (type) {
      case "canPerformAdminActions":
        newPermissionList = trinFormsPermissions.map(
          (item) => item.bpId === e.bpId ? { ...item, canPerformAdminActions: !e.canPerformAdminActions } : item
        );
        break;
      case "canEdit":
        newPermissionList = trinFormsPermissions.map(
          (item) => item.bpId === e.bpId ? { ...item, canEdit: !e.canEdit } : item
        );
        break;
      case "canApprove":
        newPermissionList = trinFormsPermissions.map(
          (item) => item.bpId === e.bpId ? { ...item, canApprove: !e.canApprove } : item
        );
        break;
      case "canCreate":
        newPermissionList = trinFormsPermissions.map(
          (item) => item.bpId === e.bpId ? { ...item, canCreate: !e.canCreate } : item
        );
        break;
      case "canUnrestrictedSearch":
        newPermissionList = trinFormsPermissions.map(
          (item) => item.bpId === e.bpId ? { ...item, canUnrestrictedSearch: !e.canUnrestrictedSearch } : item
        );
        break;
      default:
        newPermissionList = [...trinFormsPermissions];
        break;
    }
    let updatedRole = JSON.parse(JSON.stringify(currentRole));
    updatedRole.trinFormsPermissions = newPermissionList;
    updateCurrentRole(updatedRole);
    updateIsDirty(true);
    updateTrinFormsPermissions(newPermissionList);
  };
  const onChangeRoleName = (e) => {
    let role = JSON.parse(JSON.stringify(currentRole));
    role.name = e.target.value;
    updateCurrentRole(role);
    updateIsDirty(true);
  };
  const onChangeWfStepRolePermission = (e) => {
    let updatedList = [];
    if (e.isPermitted === true) {
      updatedList = wfStepRPList.map(
        (item) => item.stepId === e.stepId ? { ...item, isPermitted: false } : item
      );
      updateWfStepRPList(updatedList);
    } else {
      updatedList = wfStepRPList.map(
        (item) => item.stepId === e.stepId ? { ...item, isPermitted: true } : item
      );
      updateWfStepRPList(updatedList);
    }
    let role = JSON.parse(JSON.stringify(currentRole));
    let bp = role.permissions.find((p) => p.bpId === currentBp);
    bp.stepPermissions = updatedList;
    updateCurrentRole(role);
    updateIsDirty(true);
  };
  const onChangeAllWfStepRolePermission = (e) => {
    let updatedList = [];
    if (allStepsChecked === true) {
      updatedList = wfStepRPList.map((item) => ({
        ...item,
        isPermitted: false
      }));
      updateAllStepsChecked(false);
    } else {
      updatedList = wfStepRPList.map((item) => ({
        ...item,
        isPermitted: true
      }));
      updateAllStepsChecked(true);
    }
    let role = JSON.parse(JSON.stringify(currentRole));
    let bp = role.permissions.find((p) => p.bpId === currentBp);
    bp.stepPermissions = updatedList;
    updateCurrentRole(role);
    updateWfStepRPList(updatedList);
    updateIsDirty(true);
  };
  const onFieldPermissionAdd = () => {
    let fieldInput = document.getElementById("fp-fieldSelect");
    let operatorInput = document.getElementById("fp-operator");
    let valInput = document.getElementById("fp-value");
    let groupIdInput = document.getElementById("fp-groupId");
    if (fieldInput.value > 0 && operatorInput.value !== "") {
      let groupId = 1;
      if (groupIdInput.value !== "") groupId = parseInt(groupIdInput.value, 10);
      let fieldPermissions2 = [...currentFieldPermissionSet];
      let fieldPermissions = JSON.parse(JSON.stringify(fieldPermissions2));
      let permission = fieldPermissions.find((p) => p.groupId === groupId);
      if (permission) {
        let targetField = allFields.find(
          (a) => a.fieldId === parseInt(fieldInput.value, 10)
        );
        let newRule = {};
        newRule.description = `${targetField.displayName} ${operatorInput.value} ${valInput.value}`;
        newRule.operator = operatorInput.value;
        newRule.fieldId = targetField.fieldId;
        newRule.value = valInput.value;
        permission.rules.push(newRule);
      } else {
        let targetField = allFields.find(
          (a) => a.fieldId === parseInt(fieldInput.value, 10)
        );
        let newGroup = { groupId };
        newGroup.rules = [];
        let newRule = {};
        newRule.description = `${targetField.displayName} ${operatorInput.value} ${valInput.value}`;
        newRule.operator = operatorInput.value;
        newRule.fieldId = targetField.fieldId;
        newRule.value = valInput.value;
        newGroup.rules.push(newRule);
        fieldPermissions.push(newGroup);
      }
      updateCurrentFieldPermissionSet(fieldPermissions);
      updateFieldPermissionsDirty(true);
      updateIsDirty(true);
      let role = JSON.parse(JSON.stringify(currentRole));
      let bp = role.permissions.find((p) => p.bpId === currentBp);
      bp.groups = fieldPermissions;
      updateCurrentRole(role);
      fieldInput.value = "0";
      operatorInput.value = "";
      valInput.value = "";
      groupIdInput = "";
    }
  };
  const onFieldPermissionDelete = (grpId, fieldId, rule) => {
    let fieldPermissions2 = [...currentFieldPermissionSet];
    let fieldPermissions = JSON.parse(JSON.stringify(fieldPermissions2));
    let group = fieldPermissions.find((g) => g.groupId === grpId);
    let ruleToDelete = group.rules.find((r) => r.description === rule.description);
    if (ruleToDelete) {
      let idx = group.rules.indexOf(ruleToDelete);
      group.rules.splice(idx, 1);
      if (group.rules.length === 0) {
        let idx2 = fieldPermissions.indexOf(group);
        fieldPermissions.splice(idx2, 1);
      }
    }
    let updatedRole = JSON.parse(JSON.stringify(currentRole));
    let bp = updatedRole.permissions.find((p) => p.bpId === currentBp);
    bp.groups = fieldPermissions;
    updateCurrentRole(updatedRole);
    updateCurrentFieldPermissionSet(fieldPermissions);
    updateFieldPermissionsDirty(true);
    updateIsDirty(true);
  };
  const onShowAddUser = () => {
    updateShowAddUser(true);
  };
  const onSelectUser = (user) => {
    updateSelectedUser(user);
  };
  const onAddUser = () => {
    if (selectedUser !== void 0) {
      let user = allUsers.find(
        (u) => u.userId === selectedUser
      );
      if (user !== void 0) {
        let userList = [...users];
        let exUser = users.find((u) => u.userId === user.userId);
        if (exUser === void 0) {
          userList.push(user);
          updateUsers(userList);
          updateAddUserDirty(true);
        }
      }
    }
  };
  const onDeleteUser = (user) => {
    let userList = [...users];
    let u2 = userList.find((u) => u.userId === user.userId);
    let idx = userList.indexOf(u2);
    if (idx >= 0) {
      userList.splice(idx, 1);
      updateUsers(userList);
      updateAddUserDirty(true);
    }
  };
  const onSaveUsers = () => {
    UpdateUsersInRole(currentRole.id, users);
    updateAddUserDirty(false);
  };
  let listOfBps;
  if (roleType === "TrinDocs") {
    if (rolePermissionList !== null) {
      listOfBps = rolePermissionList.map((rp) => /* @__PURE__ */ React.createElement("div", { key: rp.bpId, className: "row" }, /* @__PURE__ */ React.createElement("div", { className: "col-sm-2 ", style: { fontWeight: "600" } }, /* @__PURE__ */ React.createElement(
        "span",
        {
          className: `${currentBp === rp.bpId ? "role-permission-selection" : ""} `,
          style: { cursor: "pointer" },
          onClick: () => {
            switchBP(rp);
          }
        },
        /* @__PURE__ */ React.createElement("i", { className: "fa-solid fa-shield-alt" }),
        " ",
        rp.bpName
      ), /* @__PURE__ */ React.createElement(
        "span",
        {
          onClick: () => {
            deleteRolePermission(rp);
          },
          style: {
            cursor: "pointer",
            color: "#C0392B",
            paddingLeft: "10px"
          }
        },
        /* @__PURE__ */ React.createElement("i", { className: "fa-solid fa-trash" })
      )), /* @__PURE__ */ React.createElement("div", { className: "col rolePermissionCheck" }, /* @__PURE__ */ React.createElement(
        "input",
        {
          className: "mt-1",
          onChange: () => onSelectAllAvailable(rp),
          checked: rp.allChecked,
          type: "checkbox",
          style: { width: "18px", height: "18px" }
        }
      )), /* @__PURE__ */ React.createElement("div", { className: "col rolePermissionCheck" }, /* @__PURE__ */ React.createElement(
        "input",
        {
          className: "mt-1",
          onChange: () => onChangePermission("canMoveAssign", rp),
          checked: rp.canMoveAssign,
          type: "checkbox",
          style: { width: "18px", height: "18px" },
          disabled: currentLicenseLevel < 3 ? "disabled" : ""
        }
      )), /* @__PURE__ */ React.createElement(
        "div",
        {
          className: "col  rolePermissionCheck",
          style: { textAlign: "center" }
        },
        /* @__PURE__ */ React.createElement(
          "input",
          {
            onChange: () => onChangePermission("canTemplate", rp),
            checked: rp.canTemplate,
            type: "checkbox",
            disabled: currentLicenseLevel < 3 ? "disabled" : ""
          }
        )
      ), /* @__PURE__ */ React.createElement(
        "div",
        {
          className: "col  rolePermissionCheck",
          style: { textAlign: "center" }
        },
        /* @__PURE__ */ React.createElement(
          "input",
          {
            onChange: () => onChangePermission("canDelete", rp),
            checked: rp.canDelete,
            type: "checkbox",
            disabled: currentLicenseLevel < 3 ? "disabled" : ""
          }
        )
      ), /* @__PURE__ */ React.createElement(
        "div",
        {
          className: "col rolePermissionCheck",
          style: { textAlign: "center" }
        },
        /* @__PURE__ */ React.createElement(
          "input",
          {
            onChange: () => onChangePermission("canImageReview", rp),
            checked: rp.canImageReview,
            type: "checkbox",
            disabled: currentLicenseLevel < 3 ? "disabled" : ""
          }
        )
      ), /* @__PURE__ */ React.createElement(
        "div",
        {
          className: "col rolePermissionCheck",
          style: { textAlign: "center" }
        },
        /* @__PURE__ */ React.createElement(
          "input",
          {
            onChange: () => onChangePermission("canApprove", rp),
            checked: rp.canApprove,
            type: "checkbox",
            disabled: currentLicenseLevel < 2 ? "disabled" : ""
          }
        )
      ), /* @__PURE__ */ React.createElement(
        "div",
        {
          className: "col rolePermissionCheck",
          style: { textAlign: "center" }
        },
        /* @__PURE__ */ React.createElement(
          "input",
          {
            onChange: () => onChangePermission("canEditFields", rp),
            checked: rp.canEditFields,
            type: "checkbox",
            disabled: currentLicenseLevel < 2 ? "disabled" : ""
          }
        )
      ), /* @__PURE__ */ React.createElement("div", { className: "col rolePermissionCheck" }, /* @__PURE__ */ React.createElement(
        "input",
        {
          onChange: () => onChangePermission("canAddNotes", rp),
          checked: rp.canAddNotes,
          type: "checkbox",
          disabled: currentLicenseLevel < 1 ? "disabled" : ""
        }
      )), /* @__PURE__ */ React.createElement(
        "div",
        {
          className: "col rolePermissionCheck",
          style: { textAlign: "center" }
        },
        /* @__PURE__ */ React.createElement(
          "input",
          {
            onChange: () => onChangePermission("canViewActiveDocs", rp),
            checked: rp.canViewActiveDocs,
            type: "checkbox",
            disabled: currentLicenseLevel < 1 ? "disabled" : ""
          }
        )
      ), /* @__PURE__ */ React.createElement(
        "div",
        {
          className: "col rolePermissionCheck",
          style: { textAlign: "center" }
        },
        /* @__PURE__ */ React.createElement(
          "input",
          {
            onChange: () => onChangePermission("canUpload", rp),
            checked: rp.canUpload,
            type: "checkbox",
            disabled: currentLicenseLevel < 1 ? "disabled" : ""
          }
        )
      ), /* @__PURE__ */ React.createElement(
        "div",
        {
          className: "col rolePermissionCheck",
          style: { textAlign: "center" }
        },
        /* @__PURE__ */ React.createElement(
          "input",
          {
            onChange: () => onChangePermission("canDownload", rp),
            checked: rp.canDownload,
            type: "checkbox",
            disabled: currentLicenseLevel < 1 ? "disabled" : ""
          }
        )
      ), /* @__PURE__ */ React.createElement(
        "div",
        {
          className: "col rolePermissionCheck",
          style: { textAlign: "center" }
        },
        /* @__PURE__ */ React.createElement(
          "input",
          {
            onChange: () => onChangePermission("canView", rp),
            checked: rp.canView,
            type: "checkbox",
            disabled: currentLicenseLevel < 1 ? "disabled" : ""
          }
        )
      ), /* @__PURE__ */ React.createElement(
        "div",
        {
          className: "col rolePermissionCheck",
          style: { textAlign: "center" }
        },
        /* @__PURE__ */ React.createElement(
          "input",
          {
            onChange: () => onChangePermission("canSearchAllSteps", rp),
            checked: rp.canSearchAllSteps,
            type: "checkbox",
            disabled: currentLicenseLevel < 1 ? "disabled" : ""
          }
        )
      )));
    } else {
      listOfBps = /* @__PURE__ */ React.createElement("div", null);
    }
  }
  if (roleType === "TrinForms") {
    if (trinFormsPermissions !== null) {
      listOfBps = trinFormsPermissions.map((rp) => /* @__PURE__ */ React.createElement("div", { key: rp.bpId, className: "row" }, /* @__PURE__ */ React.createElement("div", { className: "col-sm-2 ", style: { fontWeight: "600" } }, /* @__PURE__ */ React.createElement(
        "span",
        {
          style: { cursor: "pointer" }
        },
        /* @__PURE__ */ React.createElement("i", { className: "fa-solid fa-shield-alt" }),
        " ",
        rp.bpName
      ), /* @__PURE__ */ React.createElement(
        "span",
        {
          onClick: () => {
            deleteTrinFormsRolePermission(rp);
          },
          style: {
            cursor: "pointer",
            color: "#C0392B",
            paddingLeft: "10px"
          }
        },
        /* @__PURE__ */ React.createElement("i", { className: "fa-solid fa-trash" })
      )), /* @__PURE__ */ React.createElement("div", { className: "col rolePermissionCheck" }, /* @__PURE__ */ React.createElement(
        "input",
        {
          className: "mt-1",
          onChange: () => onChangeTrinFormsPermission("canPerformAdminActions", rp),
          checked: rp.canPerformAdminActions,
          type: "checkbox",
          style: { width: "18px", height: "18px" },
          disabled: currentLicenseLevel < 2 ? "disabled" : ""
        }
      )), /* @__PURE__ */ React.createElement(
        "div",
        {
          className: "col  rolePermissionCheck",
          style: { textAlign: "center" }
        },
        /* @__PURE__ */ React.createElement(
          "input",
          {
            onChange: () => onChangeTrinFormsPermission("canApprove", rp),
            checked: rp.canApprove,
            type: "checkbox",
            disabled: currentLicenseLevel < 1 ? "disabled" : ""
          }
        )
      ), /* @__PURE__ */ React.createElement(
        "div",
        {
          className: "col  rolePermissionCheck",
          style: { textAlign: "center" }
        },
        /* @__PURE__ */ React.createElement(
          "input",
          {
            onChange: () => onChangeTrinFormsPermission("canEdit", rp),
            checked: rp.canEdit,
            type: "checkbox",
            disabled: currentLicenseLevel < 1 ? "disabled" : ""
          }
        )
      ), /* @__PURE__ */ React.createElement(
        "div",
        {
          className: "col rolePermissionCheck",
          style: { textAlign: "center" }
        },
        /* @__PURE__ */ React.createElement(
          "input",
          {
            onChange: () => onChangeTrinFormsPermission("canCreate", rp),
            checked: rp.canCreate,
            type: "checkbox",
            disabled: currentLicenseLevel < 1 ? "disabled" : ""
          }
        )
      ), /* @__PURE__ */ React.createElement(
        "div",
        {
          className: "col rolePermissionCheck",
          style: { textAlign: "center" }
        },
        /* @__PURE__ */ React.createElement(
          "input",
          {
            onChange: () => onChangeTrinFormsPermission("canUnrestrictedSearch", rp),
            checked: rp.canUnrestrictedSearch,
            type: "checkbox",
            disabled: currentLicenseLevel < 1 ? "disabled" : ""
          }
        )
      )));
    } else {
      listOfBps = /* @__PURE__ */ React.createElement("div", null);
    }
  }
  return /* @__PURE__ */ React.createElement("div", { className: "sidebarLayout d-flex flex-row flex-fill" }, /* @__PURE__ */ React.createElement("div", { className: "sidebar-container" }, /* @__PURE__ */ React.createElement(RolesSidebar, null)), /* @__PURE__ */ React.createElement("div", { className: "flex-fill" }, /* @__PURE__ */ React.createElement("div", { className: "d-flex flex-column" }, /* @__PURE__ */ React.createElement("div", { className: "p-2", style: { backgroundColor: "rgba(0,0,0,0.03)", borderBottom: "solid 1px #CCC" } }, /* @__PURE__ */ React.createElement("div", { style: { float: "left", paddingTop: "10px" } }, "Roles"), /* @__PURE__ */ React.createElement(
    "div",
    {
      style: {
        float: "left",
        marginTop: "2px",
        paddingLeft: "20px"
      }
    },
    /* @__PURE__ */ React.createElement(
      "button",
      {
        className: "btn btn-primary",
        onClick: onShowUsers,
        style: { marginLeft: "20px" }
      },
      "Users in Role"
    )
  ), /* @__PURE__ */ React.createElement("div", { style: { float: "right", marginTop: "-12px" } }, /* @__PURE__ */ React.createElement("div", { className: "col" }, /* @__PURE__ */ React.createElement(
    "button",
    {
      className: "btn btn-success mt-3",
      onClick: onSaveClick,
      style: { marginLeft: "30px" },
      disabled: !isDirty
    },
    /* @__PURE__ */ React.createElement("i", { className: "fa-solid fa-save" }),
    " Save Changes"
  ))))), /* @__PURE__ */ React.createElement("div", { className: "flex-fill", style: { backgroundColor: "#FFF", height: `${screenHeight}px`, overflowY: "auto" } }, roleType === "TrinDocs" && /* @__PURE__ */ React.createElement("div", { id: "userRoles", className: "card m-3" }, /* @__PURE__ */ React.createElement("div", { className: "card-header" }, /* @__PURE__ */ React.createElement("div", null, "Business Processes")), /* @__PURE__ */ React.createElement("div", { className: "card-body" }, /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", { className: "form-group" }, /* @__PURE__ */ React.createElement("label", { htmlFor: "txtUserName" }, "Name"), /* @__PURE__ */ React.createElement(
    "input",
    {
      type: "text",
      className: `form-control`,
      id: "txtUserName",
      value: currentRole.name,
      onChange: onChangeRoleName,
      placeholder: "Name"
    }
  ))), /* @__PURE__ */ React.createElement("div", { className: "row" }, /* @__PURE__ */ React.createElement("div", { className: "col-sm-2" }, /* @__PURE__ */ React.createElement("div", { className: "form-group" }, /* @__PURE__ */ React.createElement("label", { htmlFor: "txtUserName" }, "License Level"), /* @__PURE__ */ React.createElement(Dropdown, null, /* @__PURE__ */ React.createElement(
    Dropdown.Toggle,
    {
      id: "ddLicenseLevel",
      className: currentLicStyle
    },
    currentLicenseName
  ), /* @__PURE__ */ React.createElement(Dropdown.Menu, null, /* @__PURE__ */ React.createElement(
    Dropdown.Item,
    {
      onClick: () => setLicenseLevel(1)
    },
    "Viewer"
  ), /* @__PURE__ */ React.createElement(
    Dropdown.Item,
    {
      onClick: () => setLicenseLevel(2)
    },
    "Approver"
  ), /* @__PURE__ */ React.createElement(
    Dropdown.Item,
    {
      onClick: () => setLicenseLevel(3)
    },
    "Admin"
  )))), /* @__PURE__ */ React.createElement("span", { className: "td-appLink", onClick: onShowUsers }, "Manage Users")), /* @__PURE__ */ React.createElement(
    "div",
    {
      className: "p-2",
      style: {
        //backgroundColor: 'rgb(143,188,143)',
        textAlign: "center",
        verticalAlign: "middle",
        display: "table",
        width: "45px",
        maxWidth: "45px",
        borderTop: "solid 1px #777",
        borderBottom: "solid 1px #777",
        borderLeft: "solid 1px #777"
      }
    },
    /* @__PURE__ */ React.createElement(
      "span",
      {
        style: {
          writingMode: "vertical-rl",
          transform: "scale(-1)",
          display: "table-cell",
          verticalAlign: "middle",
          fontSize: "14pt"
        }
      },
      "Select All"
    )
  ), /* @__PURE__ */ React.createElement(
    "div",
    {
      className: "p-2 rolePermissionLabel",
      style: {
        backgroundColor: "rgb(143,188,143)"
      }
    },
    /* @__PURE__ */ React.createElement(
      "span",
      {
        style: {
          writingMode: "vertical-rl",
          transform: "scale(-1)",
          display: "table-cell",
          verticalAlign: "middle",
          fontSize: "14pt"
        }
      },
      "Move/Assign"
    )
  ), /* @__PURE__ */ React.createElement(
    "div",
    {
      className: "p-2 rolePermissionLabel",
      style: {
        backgroundColor: "rgb(143,188,143)"
      }
    },
    /* @__PURE__ */ React.createElement(
      "span",
      {
        style: {
          writingMode: "vertical-rl",
          transform: "scale(-1)",
          display: "table-cell",
          verticalAlign: "middle",
          maxWidth: "20px",
          fontSize: "14pt"
        }
      },
      "Edit Templates"
    )
  ), /* @__PURE__ */ React.createElement(
    "div",
    {
      className: "p-2 rolePermissionLabel",
      style: {
        backgroundColor: "rgb(143,188,143)"
      }
    },
    /* @__PURE__ */ React.createElement(
      "span",
      {
        style: {
          writingMode: "vertical-rl",
          transform: "scale(-1)",
          display: "table-cell",
          verticalAlign: "middle",
          maxWidth: "20px",
          fontSize: "14pt"
        }
      },
      "Delete Documents"
    )
  ), /* @__PURE__ */ React.createElement(
    "div",
    {
      className: "p-2 rolePermissionLabel",
      style: {
        backgroundColor: "rgb(143,188,143)",
        textAlign: "center",
        verticalAlign: "middle",
        display: "table",
        width: "45px",
        maxWidth: "45px"
      }
    },
    /* @__PURE__ */ React.createElement(
      "span",
      {
        style: {
          writingMode: "vertical-rl",
          transform: "scale(-1)",
          display: "table-cell",
          verticalAlign: "middle",
          fontSize: "14pt"
        }
      },
      "Image Review"
    )
  ), /* @__PURE__ */ React.createElement(
    "div",
    {
      className: "p-2 rolePermissionLabel",
      style: {
        backgroundColor: "rgb(30, 144, 255)",
        textAlign: "center",
        verticalAlign: "middle",
        display: "table",
        width: "45px",
        maxWidth: "45px"
      }
    },
    /* @__PURE__ */ React.createElement(
      "span",
      {
        style: {
          writingMode: "vertical-rl",
          transform: "scale(-1)",
          display: "table-cell",
          verticalAlign: "middle",
          fontSize: "14pt"
        }
      },
      "Approve"
    )
  ), /* @__PURE__ */ React.createElement(
    "div",
    {
      className: "p-2 rolePermissionLabel",
      style: {
        backgroundColor: "rgb(30, 144, 255)",
        textAlign: "center",
        verticalAlign: "middle",
        display: "table",
        width: "45px",
        maxWidth: "45px"
      }
    },
    /* @__PURE__ */ React.createElement(
      "span",
      {
        style: {
          writingMode: "vertical-rl",
          transform: "scale(-1)",
          display: "table-cell",
          verticalAlign: "middle",
          fontSize: "14pt"
        }
      },
      "Edit"
    )
  ), /* @__PURE__ */ React.createElement(
    "div",
    {
      className: "p-2 rolePermissionLabel",
      style: {
        backgroundColor: "rgb(250, 250, 210)",
        textAlign: "center",
        verticalAlign: "middle",
        display: "table",
        width: "45px",
        maxWidth: "45px"
      }
    },
    /* @__PURE__ */ React.createElement(
      "span",
      {
        style: {
          writingMode: "vertical-rl",
          transform: "scale(-1)",
          display: "table-cell",
          verticalAlign: "middle",
          fontSize: "14pt"
        }
      },
      "Add Notes"
    )
  ), /* @__PURE__ */ React.createElement(
    "div",
    {
      className: "p-2 rolePermissionLabel",
      style: {
        backgroundColor: "rgb(250, 250, 210)",
        textAlign: "center",
        verticalAlign: "middle",
        display: "table",
        width: "45px",
        maxWidth: "45px"
      }
    },
    /* @__PURE__ */ React.createElement(
      "span",
      {
        style: {
          writingMode: "vertical-rl",
          transform: "scale(-1)",
          display: "table-cell",
          verticalAlign: "middle",
          fontSize: "14pt"
        }
      },
      "View in Active Docs"
    )
  ), /* @__PURE__ */ React.createElement(
    "div",
    {
      className: "p-2 rolePermissionLabel",
      style: {
        backgroundColor: "rgb(250, 250, 210)",
        textAlign: "center",
        verticalAlign: "middle",
        display: "table",
        width: "45px",
        maxWidth: "45px"
      }
    },
    /* @__PURE__ */ React.createElement(
      "span",
      {
        style: {
          writingMode: "vertical-rl",
          transform: "scale(-1)",
          display: "table-cell",
          verticalAlign: "middle",
          fontSize: "14pt"
        }
      },
      "Web Upload"
    )
  ), /* @__PURE__ */ React.createElement(
    "div",
    {
      className: "p-2 rolePermissionLabel",
      style: {
        backgroundColor: "rgb(250, 250, 210)",
        textAlign: "center",
        verticalAlign: "middle",
        display: "table",
        width: "45px",
        maxWidth: "45px"
      }
    },
    /* @__PURE__ */ React.createElement(
      "span",
      {
        style: {
          writingMode: "vertical-rl",
          transform: "scale(-1)",
          display: "table-cell",
          verticalAlign: "middle",
          fontSize: "14pt"
        }
      },
      "Download"
    )
  ), /* @__PURE__ */ React.createElement(
    "div",
    {
      className: "p-2 rolePermissionLabel",
      style: {
        backgroundColor: "rgb(250, 250, 210)",
        textAlign: "center",
        verticalAlign: "middle",
        display: "table",
        width: "45px",
        maxWidth: "45px"
      }
    },
    /* @__PURE__ */ React.createElement(
      "span",
      {
        style: {
          writingMode: "vertical-rl",
          transform: "scale(-1)",
          display: "table-cell",
          verticalAlign: "middle",
          fontSize: "14pt"
        }
      },
      "View"
    )
  ), /* @__PURE__ */ React.createElement(
    "div",
    {
      className: "p-2 rolePermissionLabel",
      style: {
        backgroundColor: "rgb(250, 250, 210)",
        textAlign: "center",
        verticalAlign: "middle",
        display: "table",
        width: "45px",
        maxWidth: "45px"
      }
    },
    /* @__PURE__ */ React.createElement(
      "span",
      {
        style: {
          writingMode: "vertical-rl",
          transform: "scale(-1)",
          display: "table-cell",
          verticalAlign: "middle",
          fontSize: "14pt"
        }
      },
      "Search all Steps"
    )
  )), listOfBps, /* @__PURE__ */ React.createElement("div", { className: "pt-4" }, !displayBPSelectDropdown && /* @__PURE__ */ React.createElement(
    "button",
    {
      className: "btn btn-success",
      onClick: filterBPList
    },
    "+ Add Business Process"
  ), displayBPSelectDropdown && /* @__PURE__ */ React.createElement("div", { className: "form-group" }, /* @__PURE__ */ React.createElement("div", { style: { float: "left" }, className: "me-2" }, /* @__PURE__ */ React.createElement(
    "select",
    {
      className: "form-select me-2",
      value: currentRp.businessProcessId,
      onChange: handleNewBPDropdown
    },
    bpList.map((bp) => /* @__PURE__ */ React.createElement("option", { key: bp.bpId, value: bp.bpId }, bp.bpName))
  )), /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(
    "button",
    {
      className: "btn btn-success",
      onClick: addNewRPToList
    },
    /* @__PURE__ */ React.createElement("i", { className: "fa-solid fa-plus" }),
    " Add"
  ))), /* @__PURE__ */ React.createElement(
    "button",
    {
      className: "btn btn-danger",
      style: { float: "right" },
      onClick: openDeleteBox
    },
    "Delete"
  )))), roleType === "TrinForms" && /* @__PURE__ */ React.createElement("div", { id: "userRoles", className: "card m-3" }, /* @__PURE__ */ React.createElement("div", { className: "card-header" }, /* @__PURE__ */ React.createElement("div", null, "Business Processes")), /* @__PURE__ */ React.createElement("div", { className: "card-body" }, /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", { className: "form-group" }, /* @__PURE__ */ React.createElement("label", { htmlFor: "txtUserName" }, "Name"), /* @__PURE__ */ React.createElement(
    "input",
    {
      type: "text",
      className: `form-control`,
      id: "txtUserName",
      value: currentRole.name,
      onChange: onChangeRoleName,
      placeholder: "Name"
    }
  ))), /* @__PURE__ */ React.createElement("div", { className: "row" }, /* @__PURE__ */ React.createElement("div", { className: "col-sm-2" }, /* @__PURE__ */ React.createElement("div", { className: "form-group" }, /* @__PURE__ */ React.createElement("label", { htmlFor: "txtUserName" }, "License Level"), /* @__PURE__ */ React.createElement(Dropdown, null, /* @__PURE__ */ React.createElement(
    Dropdown.Toggle,
    {
      id: "ddLicenseLevel",
      className: currentLicStyle
    },
    currentLicenseName
  ), /* @__PURE__ */ React.createElement(Dropdown.Menu, null, /* @__PURE__ */ React.createElement(
    Dropdown.Item,
    {
      onClick: () => setTrinFormsLicenseLevel(1)
    },
    "Standard"
  ), /* @__PURE__ */ React.createElement(
    Dropdown.Item,
    {
      onClick: () => setTrinFormsLicenseLevel(2)
    },
    "Admin"
  )))), /* @__PURE__ */ React.createElement("span", { className: "td-appLink", onClick: onShowUsers }, "Manage Users")), /* @__PURE__ */ React.createElement(
    "div",
    {
      className: "p-2 rolePermissionLabel",
      style: {
        backgroundColor: "rgb(143,188,143)"
      }
    },
    /* @__PURE__ */ React.createElement(
      "span",
      {
        style: {
          writingMode: "vertical-rl",
          transform: "scale(-1)",
          display: "table-cell",
          verticalAlign: "middle",
          fontSize: "14pt"
        }
      },
      "Admin"
    )
  ), /* @__PURE__ */ React.createElement(
    "div",
    {
      className: "p-2 rolePermissionLabel",
      style: {
        backgroundColor: "rgb(30, 144, 255)",
        textAlign: "center",
        verticalAlign: "middle",
        display: "table",
        width: "45px",
        maxWidth: "45px"
      }
    },
    /* @__PURE__ */ React.createElement(
      "span",
      {
        style: {
          writingMode: "vertical-rl",
          transform: "scale(-1)",
          display: "table-cell",
          verticalAlign: "middle",
          fontSize: "14pt"
        }
      },
      "Approve"
    )
  ), /* @__PURE__ */ React.createElement(
    "div",
    {
      className: "p-2 rolePermissionLabel",
      style: {
        backgroundColor: "rgb(30, 144, 255)",
        textAlign: "center",
        verticalAlign: "middle",
        display: "table",
        width: "45px",
        maxWidth: "45px"
      }
    },
    /* @__PURE__ */ React.createElement(
      "span",
      {
        style: {
          writingMode: "vertical-rl",
          transform: "scale(-1)",
          display: "table-cell",
          verticalAlign: "middle",
          fontSize: "14pt"
        }
      },
      "Edit"
    )
  ), /* @__PURE__ */ React.createElement(
    "div",
    {
      className: "p-2 rolePermissionLabel",
      style: {
        backgroundColor: "rgb(30, 144, 255)",
        textAlign: "center",
        verticalAlign: "middle",
        display: "table",
        width: "45px",
        maxWidth: "45px"
      }
    },
    /* @__PURE__ */ React.createElement(
      "span",
      {
        style: {
          writingMode: "vertical-rl",
          transform: "scale(-1)",
          display: "table-cell",
          verticalAlign: "middle",
          fontSize: "14pt"
        }
      },
      "Create"
    )
  ), /* @__PURE__ */ React.createElement(
    "div",
    {
      className: "p-2 rolePermissionLabel",
      style: {
        backgroundColor: "rgb(30, 144, 255)",
        textAlign: "center",
        verticalAlign: "middle",
        display: "table",
        width: "45px",
        maxWidth: "45px"
      }
    },
    /* @__PURE__ */ React.createElement(
      "span",
      {
        style: {
          writingMode: "vertical-rl",
          transform: "scale(-1)",
          display: "table-cell",
          verticalAlign: "middle",
          fontSize: "14pt"
        }
      },
      "Unrestricted Search"
    )
  )), listOfBps, /* @__PURE__ */ React.createElement("div", { className: "pt-4" }, !displayBPSelectDropdown && /* @__PURE__ */ React.createElement(
    "button",
    {
      className: "btn btn-success",
      onClick: filterTrinFormsBPList
    },
    "+ Add Business Process"
  ), displayBPSelectDropdown && /* @__PURE__ */ React.createElement("div", { className: "form-group" }, /* @__PURE__ */ React.createElement("div", { style: { float: "left" }, className: "me-2" }, /* @__PURE__ */ React.createElement(
    "select",
    {
      className: "form-select me-2",
      value: currentRp.businessProcessId,
      onChange: handleNewBPDropdown
    },
    bpList.map((bp) => /* @__PURE__ */ React.createElement("option", { key: bp.bpId, value: bp.bpId }, bp.bpName))
  )), /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(
    "button",
    {
      className: "btn btn-success",
      onClick: addNewTrinFormsBPToList
    },
    /* @__PURE__ */ React.createElement("i", { className: "fa-solid fa-plus" }),
    " Add"
  ))), /* @__PURE__ */ React.createElement(
    "button",
    {
      className: "btn btn-danger",
      style: { float: "right" },
      onClick: openDeleteBox
    },
    "Delete"
  )))), wfStepsDisplay && roleType === "TrinDocs" && /* @__PURE__ */ React.createElement("div", { className: "row gx-0" }, /* @__PURE__ */ React.createElement("div", { className: "col-6" }, /* @__PURE__ */ React.createElement("div", { id: "wfSteps", className: "card m-3" }, /* @__PURE__ */ React.createElement("div", { className: "card-header" }, /* @__PURE__ */ React.createElement(
    "input",
    {
      className: "form-check-input",
      type: "checkbox",
      checked: allStepsChecked,
      onChange: () => onChangeAllWfStepRolePermission()
    }
  ), " ", "Step Permission", /* @__PURE__ */ React.createElement("div", { style: { float: "right" } }, /* @__PURE__ */ React.createElement("span", { onClick: closeWfStepSection }, /* @__PURE__ */ React.createElement("i", { className: "fa-solid fa-xmark" })))), /* @__PURE__ */ React.createElement("div", { className: "card-body ps-4" }, /* @__PURE__ */ React.createElement("div", { className: "form-group" }, wfStepRPList.map((wfStepRp) => /* @__PURE__ */ React.createElement("div", { key: wfStepRp.stepId, className: "row mb-3" }, /* @__PURE__ */ React.createElement("div", { className: "form-check" }, /* @__PURE__ */ React.createElement("label", { className: "form-check-label" }, wfStepRp.stepName), /* @__PURE__ */ React.createElement(
    "input",
    {
      className: "form-check-input",
      onChange: () => onChangeWfStepRolePermission(wfStepRp),
      checked: wfStepRp.isPermitted,
      type: "checkbox",
      style: { width: "18px", height: "18px" }
    }
  )))))))), /* @__PURE__ */ React.createElement("div", { className: "col-6" }, /* @__PURE__ */ React.createElement("div", { id: "fieldPermission", className: "card m-3" }, /* @__PURE__ */ React.createElement("div", { className: "card-header" }, "Field Permissions"), /* @__PURE__ */ React.createElement("div", { className: "card-body ps-4" }, /* @__PURE__ */ React.createElement("div", { className: "row" }, /* @__PURE__ */ React.createElement("div", { className: "col-6" }, /* @__PURE__ */ React.createElement("label", { className: "form-label" }, "Field"), /* @__PURE__ */ React.createElement("select", { id: "fp-fieldSelect", className: "form-select" }, /* @__PURE__ */ React.createElement("option", { value: "0" }), allFields.map((field) => /* @__PURE__ */ React.createElement("option", { key: field.fieldId, value: field.fieldId }, field.displayName)))), /* @__PURE__ */ React.createElement("div", { className: "col-6" }, /* @__PURE__ */ React.createElement("label", { className: "form-label" }, "Operator"), /* @__PURE__ */ React.createElement("select", { id: "fp-operator", className: "form-select" }, /* @__PURE__ */ React.createElement("option", null), /* @__PURE__ */ React.createElement("option", null, "="), /* @__PURE__ */ React.createElement("option", null, ">"), /* @__PURE__ */ React.createElement("option", null, "<"), /* @__PURE__ */ React.createElement("option", null, ">="), /* @__PURE__ */ React.createElement("option", null, "<="), /* @__PURE__ */ React.createElement("option", null, "\u2260")))), /* @__PURE__ */ React.createElement("div", { className: "row mt-2" }, /* @__PURE__ */ React.createElement("div", { className: "col-6" }, /* @__PURE__ */ React.createElement("label", { className: "form-label" }, "Value"), /* @__PURE__ */ React.createElement("input", { id: "fp-value", className: "form-control" })), /* @__PURE__ */ React.createElement("div", { className: "col-6" }, /* @__PURE__ */ React.createElement("label", { className: "form-label" }, "Group"), /* @__PURE__ */ React.createElement(
    "input",
    {
      id: "fp-groupId",
      type: "number",
      className: "form-control"
    }
  ))), /* @__PURE__ */ React.createElement(
    "button",
    {
      onClick: onFieldPermissionAdd,
      className: "btn btn-success mt-2"
    },
    "Add"
  ), /* @__PURE__ */ React.createElement("hr", null), currentFieldPermissionSet.map((group) => /* @__PURE__ */ React.createElement("div", { key: group.groupId, className: "mt-3" }, group.groupId > 1 && /* @__PURE__ */ React.createElement(
    "div",
    {
      style: {
        fontWeight: "600",
        marginLeft: "40px",
        marginBottom: "8px",
        fontStyle: "italic"
      }
    },
    "or"
  ), /* @__PURE__ */ React.createElement("div", { className: "card" }, /* @__PURE__ */ React.createElement("div", { className: "card-header card-header-sm" }, "Group ", group.groupId), /* @__PURE__ */ React.createElement("div", { className: "card-body" }, group.rules.map((rule) => /* @__PURE__ */ React.createElement("div", { className: "mt-1" }, /* @__PURE__ */ React.createElement("span", null, rule.description), /* @__PURE__ */ React.createElement(
    "button",
    {
      className: "btn btn-danger btn-sm ms-3",
      onClick: () => onFieldPermissionDelete(
        group.groupId,
        rule.fieldId,
        rule
      )
    },
    "x"
  )))))))))))), confirmDeleteBox && /* @__PURE__ */ React.createElement("div", { className: "td-dialogue-container" }, /* @__PURE__ */ React.createElement("div", { className: "td-dialogue card" }, /* @__PURE__ */ React.createElement("div", { className: "card-header" }, "Confirm Delete", /* @__PURE__ */ React.createElement("i", { onClick: closeModal, style: { paddingLeft: "18px" } }, /* @__PURE__ */ React.createElement("i", { className: "fa-solid fa-xmark" }))), /* @__PURE__ */ React.createElement("div", { className: "card-body" }, /* @__PURE__ */ React.createElement(
    "button",
    {
      className: "btn btn-danger",
      onClick: deleteRoleConfirmed
    },
    "Delete Role"
  )))), displayUsers && /* @__PURE__ */ React.createElement("div", { className: "td-dialogue-container" }, /* @__PURE__ */ React.createElement("div", { className: "td-dialogue card" }, /* @__PURE__ */ React.createElement("div", { className: "card-header" }, "Users in Role", /* @__PURE__ */ React.createElement(
    "i",
    {
      onClick: closeModal,
      style: { float: "right", cursor: "pointer" }
    },
    /* @__PURE__ */ React.createElement("i", { className: "fa-solid fa-xmark" })
  )), users.length >= 0 && /* @__PURE__ */ React.createElement("div", { className: "card-body", style: { overflow: "auto" } }, /* @__PURE__ */ React.createElement("div", { style: { maxHeight: "300px", overflow: "auto" } }, addUserDirty && /* @__PURE__ */ React.createElement(
    "button",
    {
      onClick: onSaveUsers,
      className: "btn btn-success"
    },
    "Save Changes"
  ), /* @__PURE__ */ React.createElement("table", { id: "usersInRole", className: "wf-StepTable" }, /* @__PURE__ */ React.createElement("thead", null, /* @__PURE__ */ React.createElement("tr", null, /* @__PURE__ */ React.createElement("th", { style: { paddingRight: "15px" } }, "First Name"), /* @__PURE__ */ React.createElement("th", { style: { paddingRight: "15px" } }, "Last Name"), /* @__PURE__ */ React.createElement("th", { style: { paddingRight: "15px" } }, "User Name"), /* @__PURE__ */ React.createElement("th", { style: { paddingRight: "15px" } }, "Email"), /* @__PURE__ */ React.createElement("th", null))), /* @__PURE__ */ React.createElement("tbody", null, users.map((user) => /* @__PURE__ */ React.createElement("tr", { key: user.id, className: "mt-1" }, /* @__PURE__ */ React.createElement("td", null, user.firstName), /* @__PURE__ */ React.createElement("td", null, user.lastName), /* @__PURE__ */ React.createElement("td", null, user.userName), /* @__PURE__ */ React.createElement("td", null, user.emailAddress), /* @__PURE__ */ React.createElement("td", null, /* @__PURE__ */ React.createElement(
    "button",
    {
      onClick: () => onDeleteUser(user),
      className: "btn btn-danger btn-sm"
    },
    /* @__PURE__ */ React.createElement("i", { className: "fa-solid fa-times" })
  ))))))), !showAddUser && /* @__PURE__ */ React.createElement(
    "button",
    {
      onClick: onShowAddUser,
      className: "btn btn-success btn-sm mt-2"
    },
    "Add Users"
  ), showAddUser && /* @__PURE__ */ React.createElement("div", { className: "row mt-2" }, /* @__PURE__ */ React.createElement(
    "div",
    {
      className: "col-6",
      style: { marginBottom: "200px" }
    },
    /* @__PURE__ */ React.createElement(
      UserSelect,
      {
        id: "role-addUser-ac",
        value: selectedUser,
        allowedValues: allUsers,
        valueField: "userId",
        displayField: "userName",
        onChange: onSelectUser
      }
    )
  ), /* @__PURE__ */ React.createElement("div", { className: "col-6" }, /* @__PURE__ */ React.createElement(
    "button",
    {
      onClick: onAddUser,
      className: "btn btn-success"
    },
    "Add"
  )))))), hasError && /* @__PURE__ */ React.createElement("div", { className: "td-dialogue-container" }, /* @__PURE__ */ React.createElement("div", { className: "td-dialogue card" }, /* @__PURE__ */ React.createElement("div", { className: "card-header" }, "Error", /* @__PURE__ */ React.createElement(
    "i",
    {
      onClick: closeModal,
      style: { float: "right", cursor: "pointer" }
    },
    /* @__PURE__ */ React.createElement("i", { className: "fa-solid fa-xmark" })
  )), users.length >= 0 && /* @__PURE__ */ React.createElement("div", { className: "card-body", style: { overflow: "auto" } }, /* @__PURE__ */ React.createElement("div", { style: { maxHeight: "300px", overflow: "auto" } }, /* @__PURE__ */ React.createElement("div", { style: { paddingBottom: "20px" } }, "There was an error deleting the Role! Resolve the following error to delete the role:"), /* @__PURE__ */ React.createElement("div", null, errorMessage)))))), /* @__PURE__ */ React.createElement(Link, { id: "rolesHomeLink", to: "/Admin/Roles", style: { display: "none" } }, "HiddenLink"));
};
export default RolesView;
